<div class="smooth-scrolling">

    <app-responsive-searchbar-black-border></app-responsive-searchbar-black-border>

    <!-- brand directory content start -->

    <!-- brand directory content start -->

    <section class="brand-directory">
        <div class="brand-container">
            <h3>all brands</h3>
            <div class="brand-directory-alphabatic">
                <ul>
                    <li (click)="selectAlphabet('all')">
                        <a [ngClass]="(alphaSelectedValue == '' ? 'active' : '')">All</a>
                    </li>
                    <li *ngFor="let alpha of alphabets; let i = index" (click)="selectAlphabet(alpha)">
                        <a [ngClass]="(alphaSelectedValue == alpha ? 'active' : '')">{{alpha}}</a>
                    </li>
                </ul>
            </div>
            <div *ngIf="!alphaSelected">
                <div *ngFor="let alpha of alphabets; let i = index">
                    <div class="brand-alphabatic-name">
                        <div class="alphabatic-title">{{alpha}}</div>
                        <div class="alphabatic-name">
                            <ul>
                                <li *ngFor="let brand of mGetBrandResponse.data; let i  = index"><a
                                        (click)="viewBrandDetail(brand)"
                                        *ngIf="brand.name.startsWith(alpha.toUpperCase()) || brand.name.startsWith(alpha.toLowerCase())">{{brand.name}}</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="alphaSelected">
                <div class="brand-alphabatic-name">
                    <div class="alphabatic-title">{{alphaSelectedValue}}</div>
                    <div class="alphabatic-name">
                        <ul>
                            <li *ngFor="let brand of mGetBrandResponse.data; let i  = index"><a
                                    (click)="viewBrandDetail(brand)"
                                    *ngIf="brand.name.startsWith(alphaSelectedValue.toUpperCase()) || brand.name.startsWith(alphaSelectedValue.toLowerCase())">{{brand.name}}</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- brand directory content end -->

    <!-- Footer START -->

    <app-footer-bg></app-footer-bg>

    <!-- Footer END -->
</div>